import { render, staticRenderFns } from "./AppointmentChooseCategoryPage.vue?vue&type=template&id=61122895"
import script from "./AppointmentChooseCategoryPage.vue?vue&type=script&lang=ts"
export * from "./AppointmentChooseCategoryPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports